import { Spinner } from '@tkww/orion-web-ds-feedback';
import { TextBody } from '@tkww/orion-web-ds-text';
import React from 'react';
import Styles from './styles.scss';

export const LoadingStep = () => {
	return (
		<div className={Styles.loadingStep} data-testid="loading-step">
			<Spinner styleType="primary" size="lg" />
			<TextBody size="lg" bold>
				Calculating your custom estimate...
			</TextBody>
		</div>
	);
};
